module.exports = __webpack_public_path__ + "static/img/index-menu-6.e76d4994.png";